import { ClearOutlined, FilterOutlined } from '@ant-design/icons';
import useTranslation from '../../localization/useTranslation';
import '../../styles/listPage.css';

/**
 * Shared page chrome for list and settings screens.
 * Matches the polished Invoices / Clients header + filter + content card pattern.
 */
const ListPageShell = ({
  icon,
  title,
  subtitle,
  count,
  countLabel,
  extraBadges,
  actions,
  filters,
  filtersTitle,
  filtersActiveCount = 0,
  onResetFilters,
  children,
  contentPadded = false,
  wrapContent = true,
  className = '',
  'data-ui-page': dataUiPage,
}) => {
  const { t } = useTranslation();
  const showFilters = filters != null;
  const activeCount = Number(filtersActiveCount) || 0;

  const content =
    children == null ? null : wrapContent ? (
      <div
        className={`list-page-content-card${contentPadded ? ' list-page-content-padded' : ''}`}
      >
        {children}
      </div>
    ) : (
      children
    );

  return (
    <div className={`list-page-container ${className}`.trim()} data-ui-page={dataUiPage}>
      <div className="list-page-header-bar">
        <div className="list-page-header-left">
          {icon ? <div className="list-page-header-icon">{icon}</div> : null}
          <div className="list-page-header-titles">
            <div className="list-page-title-row">
              <h2>{title}</h2>
              {count != null ? (
                <span className="list-page-count-badge">
                  {count}
                  {countLabel ? ` ${countLabel}` : ''}
                </span>
              ) : null}
              {extraBadges}
            </div>
            {subtitle ? <p className="list-page-subtitle">{subtitle}</p> : null}
          </div>
        </div>
        {actions ? (
          <div className="list-page-header-actions">{actions}</div>
        ) : null}
      </div>

      {showFilters ? (
        <div className="list-page-filter-card">
          <div className="list-page-filter-header">
            <div className="list-page-filter-header-left">
              <FilterOutlined className="filter-icon" />
              <span>{filtersTitle || t('common.filters') || t('invoices.filter.title') || 'Filters'}</span>
              {activeCount > 0 ? (
                <span className="list-page-active-filter-badge">
                  {activeCount} {t('common.active') || 'Active'}
                </span>
              ) : null}
            </div>
            {onResetFilters ? (
              <button
                type="button"
                className="list-page-filter-reset-btn"
                onClick={onResetFilters}
                disabled={activeCount <= 0}
              >
                <ClearOutlined />
                <span>{t('common.resetFilters')}</span>
              </button>
            ) : null}
          </div>
          {filters}
        </div>
      ) : null}

      {content}
    </div>
  );
};

export default ListPageShell;
